import { A2PRegistrationInfo } from "../models/api-models/questionnaire/a2p-registration-info";

export const getSMSConfirmHelpText = (registrationInfo: A2PRegistrationInfo, teamName: string) : string => {
    let confirmHelpText = `By signing up for our text message updates, you agree to receive text messages from ${teamName} 
                        regarding athlete recruitment, team communication, and program announcements. Message and data rates may apply. 
                        Message frequency varies. You can reply STOP at any time to opt-out of future messages. For help or to request a 
                        privacy policy, reply HELP.`;
    if (registrationInfo && registrationInfo.isBusinessProfileRegistered) {
        let termsAndConditions = 'Terms & Conditions'
        let privacyPolicy = 'Privacy Policy'
        if (registrationInfo.organizationPolicy) {
            const policy = registrationInfo.organizationPolicy;
            if (policy.privacyPolicyUrl && policy.privacyPolicyUrl.length) {
                privacyPolicy = `<a href="${policy.privacyPolicyUrl}" target = "_blank">Privacy Policy</a>`;
            }
            if (policy.smsTermsAndConditionsUrl && policy.smsTermsAndConditionsUrl.length) {
                termsAndConditions = `<a href="${policy.smsTermsAndConditionsUrl}" target = "_blank">Terms & Conditions</a>`;
            }
        }
        confirmHelpText = `By signing up for our text message updates, 
                                       you accept ${termsAndConditions} and ${privacyPolicy}, and you agree to receive text messages from ${teamName}
                                       regarding athlete recruitment and program announcements.
                                       Message and data rates may apply. Message frequency varies. You can reply HELP for help and STOP to opt - out.`;
        return confirmHelpText;
    }
}